import { Box, Stack, styled, Typography } from "@mui/material";
import Image from "next/image";
import React, { useContext, useEffect, useState } from "react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

import { desktopThumbnail, mobileThumbnail } from "../../constants/finance";
import { primary, theme } from "../../constants/theme";
import { Context } from "../../context/context";
import { useMobile } from "../../utils/findViewport";

const CustomCustomerStorySwiper = styled(Box)(() => ({
  //margin: "20px",
  ".swiper-box": {
    margin: "0px 100px",
  },
  ".head-text": {
    fontSize: "40px",
    fontWeight: "600",
    textAlign: "center",
  },
  ".secondary-head-text": {
    fontSize: "18px",
    fontWeight: "400",
    textAlign: "center",
  },
  ".image-section-one": {
    objectFit: "contain",
    width: "100% !important",
    position: "relative !important",
  },
  ".benfits-image-box": {
    width: "50px",
    height: "50px",
    margin: "15px auto",
  },
  ".benefits-turno-box": {
    display: "flex",
    justifyContent: "center",
    padding: "35px",
    marginTop: "20px",
  },
  ".benefits-text": {
    fontWeight: "400",
    fontSize: "25px",
  },
  ".image-section": {
    objectFit: "contain",
    height: "500px !important",
    width: "250px !important",
    position: "relative !important",
  },
  ".swiper-turno-india": {
    display: "block",
    ".swiper-wrapper": {
      alignItems: "center",
    },
    ".swiper-slide": {
      display: "flex",
      justifyContent: "center",
      ".thumbanil-box": {
        transform: "scale(0.8)",
      },
    },
    ".swiper-slide.swiper-slide-active": {
      ".thumbanil-box": {
        transform: "scale(1)",
      },
    },
  },

  ".iframe-info": {
    width: "100%",
    height: "315px",
  },

  ".headInfo": {
    fontSize: "28px",
    fontWeight: "600",
  },

  ".headerBorder": {
    width: "100px",
    height: "8px",
    borderRadius: "100px",
    background: primary.main,
  },

  [theme.breakpoints.down("md")]: {
    //margin: " 40px 28px",
    ".swiper-box": {
      margin: "0px",
    },
    ".image-section": {
      objectFit: "contain",
      height: "300px !important",
      width: "200px !important",
      position: "relative !important",
    },
    ".head-text": {
      fontSize: "16px",
      fontWeight: "600",
    },
    ".secondary-head-text": {
      fontSize: "12px",
      fontWeight: "400",
    },
    ".benfits-image-box": {
      width: "50px",
      height: "50px",
      margin: "15px auto",
    },
    ".benefits-turno-box": {
      display: "flex",
      justifyContent: "space-around",
      padding: "0px",
    },
    ".benefits-text": {
      fontWeight: "400",
      fontSize: "12px",
    },
    ".benefits-grid": {
      display: "flex",
      justifyContent: "space-around",
    },
    ".swiper-turno-india": {
      marginTop: "40px",
      marginLeft: "20px",
      marginRight: "20px",
      display: "block",
      ".swiper-wrapper": {
        alignItems: "center",
      },
      ".swiper-slide": {
        display: "flex",
        justifyContent: "center",
        ".thumbanil-box": {
          transform: "scale(0.7)",
        },
      },
      ".swiper-slide.swiper-slide-active": {
        ".thumbanil-box": {
          transform: "scale(1)",
        },
      },

      ".iframe-info": {
        width: "260px !important",
        height: "100% !important",
      },
      ".headInfo": {
        fontSize: "18px",
      },

      ".headerBorder": {
        width: "60px",
        height: "6px",
        borderRadius: "100px",
        background: primary.main,
      },
    },
  },
}));

const CustomerStorySwiper = () => {
  const mobile = useMobile();
  const { showReviewStoryDrawer } = useContext(Context);
  const [thumbnailArray, setThumbnailArray] = useState(desktopThumbnail);
  const [slidesPerView, setSlidesPerView] = useState(desktopThumbnail.length);
  useEffect(() => {
    if (mobile) {
      setThumbnailArray(mobileThumbnail);
      setSlidesPerView(mobileThumbnail.length - 1);
    } else {
      setThumbnailArray(desktopThumbnail);
      setSlidesPerView(desktopThumbnail.length);
    }
  }, [mobile]);

  return (
    <CustomCustomerStorySwiper>
      <Box>
        <Stack
          sx={{
            margin: { xs: "32px 16px 16px 16px", sm: "16px 0px 0px 32px" },
          }}
        >
          <Typography flexDirection={"column"} className="headInfo">
            4000+ Happy Customers
          </Typography>
          <Box className="headerBorder" />{" "}
        </Stack>
        <Box className="swiper-box">
          <Swiper
            slidesPerView={slidesPerView}
            spaceBetween={0}
            centeredSlides={true}
            pagination={false}
            loop={true}
            modules={[Pagination]}
            className="swiper-turno-india"
          >
            {thumbnailArray.map((data, index) => {
              return (
                <SwiperSlide key={index}>
                  <Box className="thumbanil-box">
                    <Image
                      src={data.imageName}
                      fill="true"
                      alt="Turno home Icon"
                      className={"image-section"}
                      effect="opacity"
                      onClick={() => {
                        showReviewStoryDrawer();
                      }}
                      loading="lazy"
                    />
                  </Box>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>
      </Box>
    </CustomCustomerStorySwiper>
  );
};

export default CustomerStorySwiper;
